export default __webpack_public_path__ + "static/media/Fern 9781843620198.f76e2605.jpg";